
import { createApi } from "@reduxjs/toolkit/query/react";
import { baseAuthQuery } from "../base/baseApi";
import { ApiResponse } from "../base/apiResponse";
import { SubjectControlTypeResponse } from "../../models/dtos";

export const subjectControlTypesApi = createApi({
  reducerPath: 'subjectControlTypesApi',
  baseQuery: baseAuthQuery('SubjectControlTypes'),
  tagTypes: ['SubjectControlType'],
  endpoints: (builder) => ({
    getSubjectControlTypes: builder.query<ApiResponse<SubjectControlTypeResponse[]>, void>({
      query: () => "",
      providesTags: ['SubjectControlType'],
    }),
    getSubjectControlTypeById: builder.query<ApiResponse<SubjectControlTypeResponse>, number>({
      query: (id) => ({ url: `/${id}` }),
      providesTags: ['SubjectControlType'],
    }),
    updateSubjectControlType: builder.mutation<ApiResponse<SubjectControlTypeResponse>, Partial<SubjectControlTypeResponse>>({
      query: (body) => ({ url: "CreateOrUpdate", method: "POST", body }),
      invalidatesTags: ['SubjectControlType'],
    }),
    deleteSubjectControlType: builder.mutation<ApiResponse<boolean>, number>({
      query: (id) => ({ url: `Delete/${id}`, method: "GET" }),
      invalidatesTags: ['SubjectControlType'],
    }),
  }),
});
